import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import TestimonialCard from "@/components/TestimonialCard";
import CTABand from "@/components/CTABand";
import api from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    api.get("/public/testimonials").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  return (
    <>
      <Seo title="Testimonials | ApexPath Client Feedback"
        description="Read genuine, approved feedback from ApexPath clients across a range of UK immigration services." />
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "Testimonials" }]}
        eyebrow="What Our Clients Say"
        title="Real People." highlight="Real Journeys."
        image="/images/consult.jpg"
        subtitle="We are proud to have supported individuals, families and businesses throughout their immigration journey. Only genuine, approved client feedback is published here." />

      <section className="bg-cream py-16">
        <div className="container-x">
          {items.length > 0 ? (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {items.map((t) => <TestimonialCard key={t.id} testimonial={t} />)}
            </div>
          ) : (
            loaded && (
              <div className="mx-auto max-w-lg rounded-xl border border-slate-200 bg-white p-10 text-center" data-testid="testimonials-empty">
                <h3 className="font-serif text-2xl font-semibold text-navy">Approved testimonials coming soon</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  We only publish genuine feedback from clients who have given their consent. Approved testimonials
                  will appear here as they are reviewed and published.
                </p>
              </div>
            )
          )}
        </div>
      </section>

      <CTABand />
    </>
  );
}
